export const Profile = ({ title }) => {
  return (
    <div className="row p2">
      <h2>User info page</h2>
      <p className="h3">Fetch data from reqres.in usersection</p>
    </div>
  );
};
